module.exports = __webpack_public_path__ + "static/banner-gruppo-pam-eae24e3a67ca7285d59bc0bec2dd10a5.webp";